// Requirement: Emit persistence counts and byte sizes only; never include
// persisted job or comment contents.
export interface PersistenceDiagnostics {
  candidateBytes: number;
  jobCount: number;
  queueCount: number;
  queueBytes: number;
  largestJobBytes: number;
}

export function runBestEffort(callback: () => void): void {
  try {
    callback();
  } catch {
    // Diagnostics must never affect application behavior.
  }
}

export function serializedBytes(value: unknown): number {
  return new TextEncoder().encode(JSON.stringify(value)).byteLength;
}

export function getPersistenceDiagnostics(
  stringifiedState: string,
  jobs: Record<string, unknown>,
  queue: unknown[],
): PersistenceDiagnostics {
  return {
    candidateBytes: new TextEncoder().encode(stringifiedState).byteLength,
    jobCount: Object.keys(jobs).length,
    queueCount: queue.length,
    queueBytes: serializedBytes(queue),
    largestJobBytes: Math.max(0, ...Object.values(jobs).map(serializedBytes)),
  };
}
